const layoutPublicMarkup = (param) => {
    return `<section class="${param.class} is-public-view js-animated-section" id="${param.id}" style="${param.style}">
                <div class="editor-section-wrap">
                    <div class="editor-section_container">
                        ${param.component}
                    </div>
                </div>
            </section>`;
}

export {layoutPublicMarkup};
